import React, { useState } from 'react';

const ContactForm = () => {
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const scriptURL = 'https://script.google.com/macros/s/AKfycbyGehwG8M61GvMMlqoVg9mI00OehLVBr95jcVIm3LblWMPYhq1AH-idkmVwYmf9dhSW7A/exec';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await fetch(scriptURL, { method: 'POST', body: new FormData(e.target) });
            setMessage('Your Response has been sent successfully!');
            setTimeout(() => {
                setMessage('');
            }, 4000);
            e.target.reset();
        } catch (error) {
            console.error('Error!', error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="contact-us-form">
            <form name="submit-to-google-sheet" data-form onSubmit={handleSubmit}>
                <input type="text" placeholder="Your Name" className="form-control" name="Name" required />
                <input type="text" placeholder="Email" className="form-control" name="Email" required />
                <textarea placeholder="Type your message here..." className="form-control" rows="9" name="Message"
                    required></textarea>
                <button className="submit-button" type="submit" disabled={isLoading}>
                    {isLoading ? 'Sending...' : 'Send message'}
                </button>

            </form>
            <span id="message" className="success-message">{message}</span>
        </div>
    )
}

export default ContactForm